import { TableHead, TableRow } from "@mui/material";
import { DataTableHeadCell } from "../data-table-head-cell";
import { DataTableCellCheckbox } from "../data-table-cell-checkbox";

export const DataTableHead = ({
  headers,
  labels,
  isAllSelected,
  selectAll,
  selectedCount,
  selectAllDisabled,
  storageKey,
  hiddenColumns,
}: {
  headers: string[];
  labels?: Record<string, string>;
  isAllSelected: boolean;
  selectAll?: () => void;
  selectedCount: number;
  selectAllDisabled?: boolean; // Optional prop to disable select all checkbox if needed
  storageKey: string;
  hiddenColumns: string[];
}) => {
  return (
    <TableHead className="data-table-head">
      <TableRow>
        {!!selectAll && (
          <DataTableCellCheckbox
            sx={{ position: "sticky", py: 0.8 }}
            disabled={selectAllDisabled}
            checked={isAllSelected}
            onChange={selectAll}
            count={selectedCount}
          />
        )}
        {headers.map((key) =>
          hiddenColumns.includes(key) ? null : (
            <DataTableHeadCell
              key={key}
              storageKey={storageKey}
              columnKey={key}
            >
              {labels?.[key] ?? key}
            </DataTableHeadCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
};
